export default __webpack_public_path__ + "static/media/SolarTilt.40a777d6.png";